import {
  MTP_BASE_URL,
  ELEMENTAR_BASE_URL,
  DLM_BASE_URL,
  AIRLINE_BASE_URL,
  GPT_BASE_URL,
  ELEMENTAR_ANALYSIS_BASE_URL
} from '../../apiRoutes';
import { http, handleErrors } from '../../services/http-wrapper';
import { Auth } from 'aws-amplify';
import axios from 'axios';

// TABELA UPLOAD
export const ApiGetUploadedFiles = async ({
  id,
  nota_type,
  type,
  error_message,
  file_name,
  page,
  per_page,
  data_inicio,
  data_fim
}) => {
  let filterGroup = {
    id,
    nota_type,
    type,
    error_message,
    file_name,
    page,
    per_page,
    data_inicio,
    data_fim
  };
  let filters = Object.keys(filterGroup)
    .filter(
      (index) =>
        filterGroup[index] != '' &&
        filterGroup[index] != undefined &&
        filterGroup[index] != null
    )
    .reduce((a, index) => ({ ...a, [index]: filterGroup[index] }), {});
  if (filterGroup.page === 0 || filterGroup.page === '0') filters.page = 1;
  let filtersArray = Object.entries(filters);
  let queryArray = [];
  for (let i = 0; filtersArray.length > i; i++) {
    let field = filtersArray[i][0];
    let value = filtersArray[i][1];
    let queryString = `&${field}=${value}`;
    queryArray.push(queryString);
  }
  let query = queryArray.join('');
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/stored_files/list?${query}`,
      user.getIdToken().getJwtToken()
    );
    if (api?.data) {
      return api.data;
    } else {
      return {};
    }
  } catch (error) {
    handleErrors(error);
  }
};

// USED ONLY IN MAKE VIEW WELCOME PAGE
export const ApiGetUploadedFilesNoType = async ({ id, page, per_page }) => {
  if (page === 0) {
    page = 1;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/stored_files/list?id=${id}&page=${page}&per_page=${per_page}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiSaveUploadedFiles = async (saveData) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${MTP_BASE_URL}/stored_files/save`,
      saveData,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiDeleteFile = async (ids) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidPut(
      `${MTP_BASE_URL}/execution/delete`,
      ids,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    // handlerErros(error);
    throw error;
  }
};

export const ApiGetTypeOptions = async (id) => {
  let size = 100;
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_BASE_URL}/arquivouploadempresa/list_files_by_company?id_empresa=${id}&person=empresa&per_page=${size}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//EXECUÇÃO API
export const ApiCreateExecution = async (executionData) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${MTP_BASE_URL}/execution/create`,
      executionData,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetExecution = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${MTP_BASE_URL}/execution/read?id_empresa=${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// DLM (10)
export const ApiPostDocumentType = async ({
  company_id,
  group_id,
  extensao,
  nome,
  sigla
}) => {
  let data = {
    company_id: company_id,
    group_id: group_id,
    extensao: extensao,
    nome: nome,
    sigla: sigla
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_types`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDocumentTypes = async (groupId) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_types?groupId=${groupId}&per_page=50`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostNewDocument = async ({
  key,
  document_type_id,
  descricao
}) => {
  let data = {
    document_type_id: document_type_id,
    descricao: descricao
  };
  if (key) {
    data.key = key;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDocumentsByType = async ({
  document_type_id,
  page,
  per_page
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/files?page=${page}&per_page=${per_page}&document_type_id=${document_type_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDoc = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${DLM_BASE_URL}/document/delete/document/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPostDLMTagDocument = async ({ document_id, tag_id }) => {
  let data = {
    document_id: document_id,
    tag_id: tag_id
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.voidPost(
      `${DLM_BASE_URL}/document/create/tag_document`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMListKeyword = async ({ page, per_page }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/palavra_chave?page=${page}&per_page=${per_page}`,
      user.getIdToken().getJwtToken(),
      { page },
      { per_page }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMKeyword = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/palavra_chave`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMKeywordDocument = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/palavra_chave_documento`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMValidateTag = async ({
  tag_id,
  document_type_id,
  document_id,
  validation,
  alerta,
  data_necessidade
}) => {
  let data = {
    tag_id: tag_id,
    document_type_id: document_type_id,
    document_id: document_id,
    validation: validation,
    alerta: alerta,
    data_necessidade: data_necessidade ? data_necessidade : ''
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPost(
      `${DLM_BASE_URL}/document/validate_tag`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMKeyword = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${DLM_BASE_URL}/document/delete/palavra_chave/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPostDLMDocumentVersion = async ({
  key,
  latest_document_id,
  versao
}) => {
  let data = {
    key: key,
    latest_document_id: latest_document_id,
    versao: versao
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_version`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDocumentApproval = async ({
  document_id,
  status,
  alerta,
  data_necessidade
}) => {
  let data = {
    document_id: document_id,
    status: status,
    alerta: alerta,
    data_necessidade: data_necessidade ? data_necessidade : ''
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${DLM_BASE_URL}/document/validate/request`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMValidateTagEmail = async ({
  list_emails,
  email_subject,
  email_body
}) => {
  try {
    let data = {
      list_emails: list_emails,
      email_subject: email_subject,
      email_body: email_body
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/email/sending`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// DLM WORKFLOW (8)
export const ApiPostDLMTag = async ({
  name,
  color,
  company_id,
  document_type_id,
  alerta
}) => {
  let data = {
    name: name,
    color: color,
    company_id: company_id,
    document_type_id: document_type_id
  };
  if (alerta) {
    data.alerta = alerta;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/work_flow/create/tag`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMTag = async ({ id, name, color, alert }) => {
  let data = {
    id: id,
    name: name,
    color: color
  };
  if (alert) {
    data.alert = alert;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPut(
      `${DLM_BASE_URL}/work_flow/update/tag`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMTags = async (document_type_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/work_flow/list/tag?document_type_id=${document_type_id}&per_page=100&page=1`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMWorkflow = async ({
  document_type_id,
  tag_orig_id,
  tag_dest_id,
  validation
}) => {
  let data = {
    document_type_id: document_type_id,
    tag_orig_id: tag_orig_id,
    tag_dest_id: tag_dest_id,
    validation: validation
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPost(
      `${DLM_BASE_URL}/work_flow/create/tag_workflow`,
      data,
      user.getIdToken().getJwtToken()
    );

    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetDLMWorkflow = async (document_type_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/work_flow/list/tag_workflow?document_type_id=${document_type_id}&per_page=100&page=1`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMTagWarning = async ({ tag_id, email, aviso }) => {
  let data = {
    tag_id: tag_id,
    email: email,
    aviso: aviso
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/work_flow/create/tag_aviso`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMTagWarning = async ({ id, email, aviso }) => {
  let data = {
    id: id,
    email: email,
    aviso: aviso
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPut(
      `${DLM_BASE_URL}/work_flow/update/tag_aviso`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMTagWarning = async (tag_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/work_flow/list/tag_aviso?tag_id=${tag_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMTag = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/work_flow/delete/tag/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiDeleteDLMTagWorkflow = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/work_flow/delete/tagworkflow/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPutDLMUpdateTagWorkflow = async ({
  id,
  id_tag_orig,
  id_tag_dest
}) => {
  let data = {
    id: id,
    id_tag_orig: id_tag_orig,
    id_tag_dest: id_tag_dest
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPut(
      `${DLM_BASE_URL}/work_flow/update/tag_work_flow`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// W/ DLM_BASE_URL
export const AltApiGetListDocumentsByType = async (document_type_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/files?document_type_id=${document_type_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//Anexos
export const ApiPostDLMAttachDocuments = async ({ id_documento, id_anexo }) => {
  try {
    let data = {
      id_documento,
      id_anexo
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/documento_anexo`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMAttachDocuments = async (idAnexo) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/documento_anexo/${idAnexo}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPostDLMAttachFiles = async ({ id_documento, key }) => {
  try {
    let data = {
      id_documento: id_documento,
      key: key
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/arquivo_anexo`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// UPLOAD DATA TO FLIGHT TABLE
export const ApiUpoloadFlightData = async ({ file_name }) => {
  let body = {
    file_name: file_name
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.altPost(
      `${AIRLINE_BASE_URL}/flights/upload/airline`,
      body,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpoloadPriceReport = async ({ file_name }) => {
  let body = {
    file_name: file_name
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.altPost(
      `${AIRLINE_BASE_URL}/flights/upload/price_report`,
      body,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//RECONCILIATION DATA
export const ApiGetReconciliationData = async ({
  page,
  per_page,
  filter_type,
  flight_number,
  item_name,
  start_date,
  end_date
}) => {
  try {
    let offset = page * per_page;
    let limit = per_page;
    let user = await Auth.currentSession();
    let url = `${AIRLINE_BASE_URL}/api/reconciliation/data?limit=${limit}&offset=${offset}`;

    if (filter_type) {
      url += `&filter_type=${filter_type}`;
    }

    if (flight_number) {
      url += `&flight_number=${flight_number}`;
    }

    if (item_name) {
      url += `&item_name=${item_name}`;
    }

    if (start_date) {
      url += `&start_date=${start_date}`;
    }

    if (end_date) {
      url += `&end_date=${end_date}`;
    }
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//RECONCILIATION ANNOTATIONS

export const ApiPostReconAnnotations = async ({
  reconciliation_id,
  annotation,
  status
}) => {
  try {
    let data = {
      reconciliation_id: reconciliation_id,
      annotation: annotation,
      status: status
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${AIRLINE_BASE_URL}/api/annotations`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetReconAnnotations = async (reconciliation_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${AIRLINE_BASE_URL}/api/annotations/by-reconciliation/${reconciliation_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutReconAnnotations = async ({ annotation_id, status }) => {
  let data = {
    annotation_id: annotation_id,
    status: status
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${AIRLINE_BASE_URL}/api/annotations`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteReconAnnotations = async (annotation_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${AIRLINE_BASE_URL}/api/annotations/${annotation_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//chatGpt FOR DLM PAGE
export const ApiChatGptDlmSummary = async ({ bucket_name, folder_name }) => {
  let body = {
    bucket_name: bucket_name,
    folder_name: folder_name
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/call_gpt_dlm_resumo_sincronize`,
      body,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptDLMQuestion = async ({
  bucket_name,
  folder_name,
  list_files,
  pergunta
}) => {
  let data = {
    bucket_name: bucket_name,
    folder_name: folder_name,
    list_files: list_files,
    pergunta: pergunta
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/store_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostChatGptDLMResponse = async ({
  bucket_name,
  folder_name,
  list_files,
  pergunta
}) => {
  let data = {
    bucket_name: bucket_name,
    folder_name: folder_name,
    list_files: list_files,
    pergunta: pergunta
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${GPT_BASE_URL}/gpt_api/find_chatgpt_response`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostDLMDepartment = async ({ company_id, name }) => {
  let data = {
    company_id: company_id,
    name: name
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/group`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMDepartment = async ({ group_id, name }) => {
  let data = {
    group_id: group_id,
    name: name
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPut(
      `${DLM_BASE_URL}/document/update/group`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMDocumentType = async ({
  document_type_id,
  name,
  acronym,
  extension
}) => {
  let data = {
    document_type_id: document_type_id,
    name: name,
    acronym: acronym,
    extension: extension
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.dlmPut(
      `${DLM_BASE_URL}/document/update/document_types`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDepartment = async (department_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/group/${department_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDocType = async (document_type_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_types/${document_type_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMDepartment = async (cnpj) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/group?cnpj=${cnpj}&per_page=50`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

// DLM (11) DocumentFeild
export const ApiPostDLMNewDocumentFeild = async ({
  document_id,
  field_name,
  field_type,
  size,
  value
}) => {
  try {
    let data = {
      document_id: document_id,
      field_name: field_name,
      field_type: field_type,
      size: size,
      value: value
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_fields`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMDocumentField = async (document_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_fields?document_id=${document_id}&per_page=50`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMDocumentFeild = async ({
  id,
  field_name,
  field_type,
  size,
  value,
  mission
}) => {
  let data = {
    id: id,
    field_name: field_name,
    field_type: field_type,
    size: size,
    value: value,
    mission: mission
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${DLM_BASE_URL}/document/update/document_fields`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDocumentFeild = async (documentFieldId) => {
  try {
    console.log('_______________', documentFieldId);
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_fields/${documentFieldId}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// DLM - Document Type Feild
export const ApiPostDLMDocTypeFields = async ({
  document_type_id,
  field_name,
  field_type,
  size
}) => {
  try {
    let data = {
      document_type_id,
      field_name,
      field_type,
      size
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_type_fields`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMDocTypeFields = async (document_type_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_type_fields?document_type_id=${document_type_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMDocTypeFields = async ({
  id,
  field_name,
  field_type,
  size
}) => {
  let data = {
    id,
    field_name,
    field_type,
    size
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${DLM_BASE_URL}/document/update/document_type_fields`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDocTypeFields = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_type_fields/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// DLM - Document Type Valid Values
export const ApiPostDLMDocTypeValidValues = async ({
  id_type_document_field,
  value
}) => {
  try {
    let data = {
      id_type_document_field,
      value
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_type_valid_value`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMDocTypeValidValues = async (id_type_document_field) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_type_valid_value?id_type_document_field=${id_type_document_field}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPutDLMDocTypeValidValues = async ({ id, value }) => {
  let data = {
    id,
    value
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${DLM_BASE_URL}/document/update/document_type_valid_value`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMDocTypeValidValues = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_type_valid_value/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

//DLM Confidencialidade
export const ApiPostDLMConfidentiality = async ({
  company_id,
  degree,
  description
}) => {
  try {
    let data = {
      company_id,
      degree,
      description
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_confidentiality`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMConfidentiality = async (cnpj) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_confidentiality?cnpj=${cnpj}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMConfidentiality = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_confidentiality/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

//DLM Acessos de usuários
export const ApiPostDLMUsersAccesses = async ({
  user_id,
  document_type_id,
  access_type,
  max_degree
}) => {
  try {
    let data = {
      user_id,
      document_type_id,
      access_type,
      max_degree
    };
    let user = await Auth.currentSession();
    const api = await http.post(
      `${DLM_BASE_URL}/document/create/document_user_access`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetDLMUsersAccesses = async (user_id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${DLM_BASE_URL}/document/list/document_user_access?user_id=${user_id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteDLMUsersAccesses = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.voidRemove(
      `${DLM_BASE_URL}/document/delete/document_user_access/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPutDLMUsersAccesses = async ({
  id,
  access_type,
  max_degree
}) => {
  let data = {
    id,
    access_type,
    max_degree
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.returnPut(
      `${DLM_BASE_URL}/document/update/document_user_access`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api;
  } catch (error) {
    handleErrors(error);
  }
};

//GESTÃO FINANCEIRA - LEVDATA
export const ApiPostCreateAccount = async ({
  IdEmpresa,
  Codgbanco,
  Nomebanco,
  Agencia,
  Numrconta,
  Tipoconta,
  Nomeconta,
  Situacao,
  SaldoInicial,
  DataSaldoInicial
}) => {
  let data = {
    IdEmpresa: IdEmpresa,
    Codgbanco: Codgbanco,
    Nomebanco: Nomebanco,
    Agencia: Agencia,
    Numrconta: Numrconta,
    Tipoconta: Tipoconta,
    Nomeconta: Nomeconta,
    Situacao: Situacao,
    SaldoInicial: SaldoInicial,
    DataSaldoInicial: DataSaldoInicial
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-account`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetListAccount = async ({
  IdEmpresa,
  Nomeconta,
  Nomebanco,
  Situacao
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-account?IdEmpresa=${IdEmpresa}`;

    if (Nomeconta) url += `&Nomeconta=${Nomeconta}`;
    if (Nomebanco) url += `&Nomebanco=${Nomebanco}`;
    if (Situacao) url += `&Situacao=${Situacao}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateAccount = async ({
  id,
  IdEmpresa,
  Nomeconta,
  Situacao,
  SaldoAtual,
  Codgbanco,
  Nomebanco,
  Agencia,
  Numrconta,
  Tipoconta,
  DataSaldoAtual,
  Motivo
}) => {
  try {
    let data = {
      id: id,
      IdEmpresa: IdEmpresa,
      Nomeconta: Nomeconta,
      Situacao: Situacao,
      SaldoAtual: SaldoAtual,
      Codgbanco: Codgbanco,
      Nomebanco: Nomebanco,
      Agencia: Agencia,
      Numrconta: Numrconta,
      Tipoconta: Tipoconta,
      DataSaldoAtual: DataSaldoAtual,
      Motivo: Motivo
    };
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-account`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteAccount = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete-account/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiPostCreateBank = async ({ name, code }) => {
  let data = {
    name: name,
    code: code
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-bank`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetListBank = async () => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-bank`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateBank = async ({ id, name, code }) => {
  try {
    let data = {
      id: id,
      name: name,
      code: code
    };
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-bank`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteBank = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete-bank/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetListExtract = async ({
  Id,
  DataInicio,
  DataFim,
  Documento,
  Categoria,
  Acao,
  Status
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-extract-details?Id=${Id}`;

    if (DataInicio) url += `&DataInicio=${DataInicio}`;
    if (DataFim) url += `&DataFim=${DataFim}`;
    if (Documento) url += `&Documento=${Documento}`;
    if (Categoria) url += `&Categoria=${Categoria}`;
    if (Acao) url += `&Acao=${Acao}`;
    if (Status) url += `&Acao=${Status}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteExtract = async (Id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete-extract/${Id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetListCategory = async ({
  IdEmpresa,
  Nome,
  Tipo,
  CatgPrincipal
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-categories-principal?IdEmpresa=${IdEmpresa}`;

    if (Nome) url += `&Nome=${Nome}`;
    if (Tipo) url += `&Tipo=${Tipo}`;
    if (CatgPrincipal) url += `&CatgPrincipal=${CatgPrincipal}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostCreateCategory = async ({
  IdEmpresa,
  Nome,
  Tipo,
  CatgPrincipal,
  Descricao,
  CalculaCusto
}) => {
  let data = {
    IdEmpresa: IdEmpresa,
    Nome: Nome,
    Tipo: Tipo,
    CalculaCusto: CalculaCusto
  };
  if (CatgPrincipal) {
    data.CatgPrincipal = CatgPrincipal;
  }

  if (Descricao) {
    data.Descricao = Descricao;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-category`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateCategory = async ({
  Id,
  Nome,
  Tipo,
  CatgPrincipal,
  Descricao,
  CalculaCusto
}) => {
  try {
    let data = {
      Id: Id,
      Nome: Nome,
      Tipo: Tipo,
      CatgPrincipal: CatgPrincipal,
      Descricao: Descricao,
      CalculaCusto: CalculaCusto
    };
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-category`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteCategory = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete-category/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetListLancamento = async ({
  IdEmpresa,
  DateInit,
  DateFim,
  Tipo,
  IdCategoria,
  page,
  per_page
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-lancamento?IdEmpresa=${IdEmpresa}&page=${page}&per_page=${per_page}`;

    if (DateInit) url += `&DateInit=${DateInit}`;
    if (DateFim) url += `&DateFim=${DateFim}`;
    if (Tipo) url += `&Tipo=${Tipo}`;
    if (IdCategoria) url += `&IdCategoria=${IdCategoria}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostCreateLancamento = async ({
  IdEmpresa,
  DataLancamento,
  DataVencimento,
  Contato,
  IdCategoria,
  Detalhamento,
  Valor,
  TipoLancamento,
  Rateio
}) => {
  let data = {
    IdEmpresa: IdEmpresa,
    DataLancamento: DataLancamento,
    DataVencimento: DataVencimento,
    Contato: Contato,
    IdCategoria: IdCategoria,
    Valor: Valor
  };
  if (Detalhamento) {
    data.Detalhamento = Detalhamento;
  }

  if (TipoLancamento) {
    data.TipoLancamento = TipoLancamento;
  }

  if (Rateio && Rateio.length) {
    data.Rateio = Rateio;
  }

  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-lancamento`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateLancamento = async ({
  Id,
  DataLancamento,
  DataVencimento,
  Contato,
  IdCategoria,
  Detalhamento,
  Valor,
  TipoLancamento,
  Rateio
}) => {
  try {
    let data = {
      Id: Id,
      DataLancamento: DataLancamento,
      DataVencimento: DataVencimento,
      Contato: Contato,
      IdCategoria: IdCategoria,
      Detalhamento: Detalhamento,
      Valor: Valor,
      TipoLancamento: TipoLancamento
    };
    if (Rateio && Rateio.length) {
      data.Rateio = Rateio;
    }
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-lancamento`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiDeleteLancamento = async (id) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.remove(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete-lancamento/${id}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const ApiGetListConciliacao = async ({
  IdConta,
  Status,
  Tipo,
  Historico,
  NumeroConta,
  page,
  per_page
}) => {
  if (page === 0) {
    page = 1;
  }
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-conta-extratos?IdConta=${IdConta}&page=${page}&per_page=${per_page}`;

    if (Status) url += `&Status=${Status}`;
    if (Tipo) url += `&Tipo=${Tipo}`;
    if (Historico) url += `&Historico=${Historico}`;
    if (NumeroConta) url += `&Historico=${NumeroConta}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetListSimulacao = async ({ IdEmpresa }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/simulacao-empresa?IdEmpresa=${IdEmpresa}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateVincMovimentacao = async ({
  Id,
  IdLancamento,
  IdCategoria,
  Status,
  Ids
}) => {
  try {
    let data = {
      Id: Id,
      IdLancamento: IdLancamento,
      IdCategoria: IdCategoria,
      Status: Status,
      Ids: Ids
    };
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/vincular-movimentacao`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateDesvincMovimentacao = async ({ Id, Ids }) => {
  try {
    let data = {
      Id: Id,
      Ids: Ids
    };
    let user = await Auth.currentSession();
    const api = await http.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/desvincular-movimentacao`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetListSimulacaoConta = async ({
  IdEmpresa,
  IdConta,
  year,
  month,
  page,
  per_page
}) => {
  if (page === 0) {
    page = 1;
  }
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/simulacao-conta?IdEmpresa=${IdEmpresa}&page=${page}&per_page=${per_page}`;
    if (IdConta) url += `&IdConta=${IdConta}`;
    if (year) url += `&year=${year}`;
    if (month) url += `&month=${month}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostCreateLancamentoConciliacao = async ({
  IdMovimentacao,
  IdEmpresa,
  DataLancamento,
  DataVencimento,
  Contato,
  IdCategoria,
  Detalhamento,
  Valor,
  TipoLancamento
}) => {
  let data = {
    IdMovimentacao: IdMovimentacao,
    IdEmpresa: IdEmpresa,
    DataLancamento: DataLancamento,
    DataVencimento: DataVencimento,
    Contato: Contato,
    IdCategoria: IdCategoria,
    Valor: Valor
  };
  if (Detalhamento) {
    data.Detalhamento = Detalhamento;
  }

  if (TipoLancamento) {
    data.TipoLancamento = TipoLancamento;
  }

  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-lancamento-conciliacao`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetExecuteConciliacao = async ({ IdConta }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/conciliacao?IdConta=${IdConta}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetGestaoFinanceiraContato = async ({ IdEmpresa }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-contato?IdEmpresa=${IdEmpresa}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetExtractMovements = async ({
  ExtractId,
  page,
  per_page,
  DataInicio,
  DataFim,
  Documento,
  Categoria,
  Acao,
  Status
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-extract-movements?ExtractId=${ExtractId}&page=${page}&per_page=${per_page}`;

    if (DataInicio) url += `&DataInicio=${DataInicio}`;
    if (DataFim) url += `&DataFim=${DataFim}`;
    if (Documento) url += `&Documento=${Documento}`;
    if (Categoria) url += `&Categoria=${Categoria}`;
    if (Acao) url += `&Acao=${Acao}`;
    if (Status) url += `&Acao=${Status}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());

    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetValidateExtract = async ({ extrato_key }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/validate-extraro?extrato_key=${extrato_key}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetTransferenciaConta = async ({
  IdConta,
  IdMovimentacao,
  DataMovimento,
  ValorMovimento
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/list-conta-movimentacao?IdConta=${IdConta}&IdMovimentacao=${IdMovimentacao}&DataMovimento=${DataMovimento}&ValorMovimento=${ValorMovimento}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostTransferenciaConta = async ({
  IdMovOrigem,
  IdMovDestino,
  IdEmpresa,
  DataVencimento,
  IdCategoriaOrigem,
  IdCategoriaDestino,
  DetalhamentoOrigem,
  DetalhamentoDestino,
  Valor,
  TipoLancamento
}) => {
  let data = {
    IdMovOrigem,
    IdMovDestino,
    IdEmpresa,
    DataVencimento,
    IdCategoriaOrigem,
    IdCategoriaDestino,
    Valor
  };
  if (DetalhamentoOrigem) {
    data.DetalhamentoOrigem = DetalhamentoOrigem;
  }
  if (DetalhamentoDestino) {
    data.DetalhamentoDestino = DetalhamentoDestino;
  }
  if (TipoLancamento) {
    data.TipoLancamento = TipoLancamento;
  }
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/transferencia/movimentacoes`,
      data,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

//LEVDATA
export const ApiGetLevdataEmpresaInfo = async ({ Cnpj, Ano, Mes, Silent }) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/empresa-info?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataImpostos = async ({ Cnpj, Ano, Mes, Silent }) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/impostos?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataMargem = async ({ Cnpj, Ano, Mes, Silent }) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/margem?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataSituacaoTributaria = async ({
  Cnpj,
  Ano,
  Mes,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/situacao-tributaria?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataLevNotas = async ({ Cnpj, Ano, Mes, Silent }) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/lev-notas?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataReceita = async ({
  Cnpj,
  TipoNota,
  RN,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/receita?Cnpj=${Cnpj}`;
  if (TipoNota) {
    url += `&TipoNota=${TipoNota}`;
  }
  if (RN !== null && RN !== undefined) {
    url += `&RN=${RN}`;
  }
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataHistoricoDashboard = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Meses,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/historico?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  if (Meses) {
    url += `&Meses=${Meses}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataLimiteUtilizado = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/limite-utilizado?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    // getSilent já não mostra toast (e relança) — chamar handleErrors aqui em
    // cima mesmo assim mostraria o erro de qualquer forma, anulando o Silent.
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataRegimeAtual = async ({ Cnpj, Silent }) => {
  try {
    let user = await Auth.currentSession();
    const url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/regime-atual?Cnpj=${Cnpj}`;
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataAliquotaAtual = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/aliquota-atual?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataDespesas = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  SemImpostos,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/despesas?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  if (SemImpostos !== undefined) {
    url += `&SemImpostos=${SemImpostos}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataCreditoPotencial = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/credito-potencial?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataComprasSemCredito = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/compras-sem-credito?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataDetalhamentoLucro = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/detalhamento-lucro?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataCreditosFiscais = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/creditos-fiscais?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

export const ApiGetLevdataFornecedorPorCredito = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/tributario/fornecedor-por-credito?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataSemCreditoPotencial = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/tributario/sem-credito-potencial?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataCreditoPisCofins = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/tributario/credito-pis-cofins?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataHistoricoCreditos = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Meses,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/tributario/historico-creditos?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  if (Meses) {
    url += `&Meses=${Meses}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataDashboardInsights = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/insights?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    const api = Silent
      ? await http.getSilent(url, user.getIdToken().getJwtToken())
      : await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    if (Silent) {
      throw error;
    }
    handleErrors(error);
  }
};

// MOTOR DE INTELIGÊNCIA (RF002/RF003/RN006) — /financeiro/dashboard/produtos,
// /clientes e /motor-insights. /acoes-rapidas foi removida (RF005 é fixo no
// MVP, ver ActionsPanel.js) - sem essa chamada de rede, o painel funciona
// igual em dev e produção, sem depender do backend estar no ar.
export const ApiGetFinanceiroDashboardProdutos = async ({
  Cnpj,
  Ano,
  Mes,
  Produto,
  DataInicio,
  DataFim,
  Origem,
  Page,
  PerPage,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/produtos?Cnpj=${Cnpj}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  if (Produto) url += `&Produto=${encodeURIComponent(Produto)}`;
  if (DataInicio) url += `&DataInicio=${DataInicio}`;
  if (DataFim) url += `&DataFim=${DataFim}`;
  if (Origem) url += `&Origem=${Origem}`;
  if (Page) url += `&Page=${Page}`;
  if (PerPage) url += `&PerPage=${PerPage}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetFinanceiroDashboardClientes = async ({
  Cnpj,
  Ano,
  Mes,
  Cliente,
  DataInicio,
  DataFim,
  Origem,
  Page,
  PerPage,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/clientes?Cnpj=${Cnpj}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  if (Cliente) url += `&Cliente=${encodeURIComponent(Cliente)}`;
  if (DataInicio) url += `&DataInicio=${DataInicio}`;
  if (DataFim) url += `&DataFim=${DataFim}`;
  if (Origem) url += `&Origem=${Origem}`;
  if (Page) url += `&Page=${Page}`;
  if (PerPage) url += `&PerPage=${PerPage}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetFinanceiroDashboardMotorInsights = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Origem,
  Page,
  PerPage,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/dashboard/motor-insights?Cnpj=${Cnpj}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  if (DataInicio) url += `&DataInicio=${DataInicio}`;
  if (DataFim) url += `&DataFim=${DataFim}`;
  if (Origem) url += `&Origem=${Origem}`;
  if (Page) url += `&Page=${Page}`;
  if (PerPage) url += `&PerPage=${PerPage}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataCenarioVendas = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/creditos-potenciais/cenario-vendas?Cnpj=${Cnpj}`;
  if (Ano) {
    url += `&Ano=${Ano}`;
  }
  if (Mes) {
    url += `&Mes=${Mes}`;
  }
  if (DataInicio) {
    url += `&DataInicio=${DataInicio}`;
  }
  if (DataFim) {
    url += `&DataFim=${DataFim}`;
  }
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataCreditosPotenciaisInsights = async ({
  Cnpj,
  Ano,
  Mes,
  DataInicio,
  DataFim,
  LR_FA,
  LR_FR,
  LR_EA,
  LR_ER,
  LP_FA,
  LP_FR,
  LP_EA,
  LP_ER,
  SN_FA,
  SN_FR,
  SN_EA,
  SN_ER,
  SNH_FA,
  SNH_FR,
  SNH_EA,
  SNH_ER
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/creditos-potenciais/insights?Cnpj=${Cnpj}`;
    if (Ano) {
      url += `&Ano=${Ano}`;
    }
    if (Mes) {
      url += `&Mes=${Mes}`;
    }
    if (DataInicio) {
      url += `&DataInicio=${DataInicio}`;
    }
    if (DataFim) {
      url += `&DataFim=${DataFim}`;
    }
    if (LR_FA) {
      url += `&LR_FA=${LR_FA}`;
    }
    if (LR_FR) {
      url += `&LR_FR=${LR_FR}`;
    }
    if (LR_EA) {
      url += `&LR_EA=${LR_EA}`;
    }
    if (LR_ER) {
      url += `&LR_ER=${LR_ER}`;
    }
    if (LP_FA) {
      url += `&LP_FA=${LP_FA}`;
    }
    if (LP_FR) {
      url += `&LP_FR=${LP_FR}`;
    }
    if (LP_EA) {
      url += `&LP_EA=${LP_EA}`;
    }
    if (LP_ER) {
      url += `&LP_ER=${LP_ER}`;
    }
    if (SN_FA) {
      url += `&SN_FA=${SN_FA}`;
    }
    if (SN_FR) {
      url += `&SN_FR=${SN_FR}`;
    }
    if (SN_EA) {
      url += `&SN_EA=${SN_EA}`;
    }
    if (SN_ER) {
      url += `&SN_ER=${SN_ER}`;
    }
    if (SNH_FA) {
      url += `&SNH_FA=${SNH_FA}`;
    }
    if (SNH_FR) {
      url += `&SNH_FR=${SNH_FR}`;
    }
    if (SNH_EA) {
      url += `&SNH_EA=${SNH_EA}`;
    }
    if (SNH_ER) {
      url += `&SNH_ER=${SNH_ER}`;
    }
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataRegimeTributarioSimulacao = async ({
  Cnpj,
  AnoCalendario,
  Ano,
  Mes,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/regime-tributario/simulacao?Cnpj=${Cnpj}`;
  if (AnoCalendario) url += `&AnoCalendario=${AnoCalendario}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataRegimeTributarioComparativo = async ({
  Cnpj,
  AnoCalendario,
  Ano,
  Mes,
  Anexo,
  Atividade,
  SujeitoFatorR,
  ReceitaMensal,
  Despesas,
  BaseCreditavelMensal,
  SimplesInss,
  SimplesRat,
  SimplesTerceiros,
  PresumidoBcIrpj,
  PresumidoBcCsll,
  PresumidoIr,
  PresumidoCsll,
  PresumidoPis,
  PresumidoCofins,
  PresumidoIss,
  PresumidoInss,
  PresumidoRat,
  PresumidoTerceiros,
  RealIbs,
  RealCbs,
  RealIr,
  RealCsll,
  RealPercentualTributavel,
  RealInss,
  RealRat,
  RealTerceiros,
  HibridoIbs,
  HibridoCbs,
  ClientePerfil,
  ClienteRegime,
  ClientePercentualCredito,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/regime-tributario/comparativo?Cnpj=${Cnpj}`;
  if (AnoCalendario) url += `&AnoCalendario=${AnoCalendario}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  if (Anexo) url += `&Anexo=${Anexo}`;
  if (Atividade) url += `&Atividade=${Atividade}`;
  if (SujeitoFatorR) url += `&SujeitoFatorR=${SujeitoFatorR}`;
  if (ReceitaMensal !== undefined && ReceitaMensal !== null)
    url += `&ReceitaMensal=${ReceitaMensal}`;
  if (Despesas !== undefined && Despesas !== null)
    url += `&Despesas=${Despesas}`;
  if (BaseCreditavelMensal !== undefined && BaseCreditavelMensal !== null)
    url += `&BaseCreditavelMensal=${BaseCreditavelMensal}`;
  if (SimplesInss !== undefined) url += `&SimplesInss=${SimplesInss}`;
  if (SimplesRat !== undefined) url += `&SimplesRat=${SimplesRat}`;
  if (SimplesTerceiros !== undefined)
    url += `&SimplesTerceiros=${SimplesTerceiros}`;
  if (PresumidoBcIrpj !== undefined)
    url += `&PresumidoBcIrpj=${PresumidoBcIrpj}`;
  if (PresumidoBcCsll !== undefined)
    url += `&PresumidoBcCsll=${PresumidoBcCsll}`;
  if (PresumidoIr !== undefined) url += `&PresumidoIr=${PresumidoIr}`;
  if (PresumidoCsll !== undefined) url += `&PresumidoCsll=${PresumidoCsll}`;
  if (PresumidoPis !== undefined) url += `&PresumidoPis=${PresumidoPis}`;
  if (PresumidoCofins !== undefined)
    url += `&PresumidoCofins=${PresumidoCofins}`;
  if (PresumidoIss !== undefined) url += `&PresumidoIss=${PresumidoIss}`;
  if (PresumidoInss !== undefined) url += `&PresumidoInss=${PresumidoInss}`;
  if (PresumidoRat !== undefined) url += `&PresumidoRat=${PresumidoRat}`;
  if (PresumidoTerceiros !== undefined)
    url += `&PresumidoTerceiros=${PresumidoTerceiros}`;
  if (RealIbs !== undefined) url += `&RealIbs=${RealIbs}`;
  if (RealCbs !== undefined) url += `&RealCbs=${RealCbs}`;
  if (RealIr !== undefined) url += `&RealIr=${RealIr}`;
  if (RealCsll !== undefined) url += `&RealCsll=${RealCsll}`;
  if (RealPercentualTributavel !== undefined)
    url += `&RealPercentualTributavel=${RealPercentualTributavel}`;
  if (RealInss !== undefined) url += `&RealInss=${RealInss}`;
  if (RealRat !== undefined) url += `&RealRat=${RealRat}`;
  if (RealTerceiros !== undefined) url += `&RealTerceiros=${RealTerceiros}`;
  if (HibridoIbs !== undefined) url += `&HibridoIbs=${HibridoIbs}`;
  if (HibridoCbs !== undefined) url += `&HibridoCbs=${HibridoCbs}`;
  if (ClientePerfil) url += `&ClientePerfil=${ClientePerfil}`;
  if (ClienteRegime) url += `&ClienteRegime=${ClienteRegime}`;
  if (
    ClientePercentualCredito !== undefined &&
    ClientePercentualCredito !== null
  )
    url += `&ClientePercentualCredito=${ClientePercentualCredito}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetLevdataRegimeTributarioMotorExecutivo = async ({
  Cnpj,
  AnoCalendario,
  Ano,
  Mes,
  Anexo,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/regime-tributario/motor-executivo?Cnpj=${Cnpj}`;
  if (AnoCalendario) url += `&AnoCalendario=${AnoCalendario}`;
  if (Ano) url += `&Ano=${Ano}`;
  if (Mes) url += `&Mes=${Mes}`;
  if (Anexo) url += `&Anexo=${Anexo}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiPostLevdataPrecificacaoNotaValor = async ({
  Cnpj,
  Tipo,
  CodProd,
  IdDados,
  ItensCompra,
  ItemVendaVinculado
}) => {
  let data = {
    Cnpj: Cnpj,
    Tipo: Tipo,
    CodProd: CodProd,
    IdDados: IdDados,
    ItensCompra: ItensCompra,
    ItemVendaVinculado: ItemVendaVinculado
  };
  try {
    let user = await Auth.currentSession();
    const api = await http.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/get-nota-valor`,
      data,
      user.getIdToken().getJwtToken()
    );
    console.log('data:', data);
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoProdutoNfe = async ({
  Cnpj,
  NCM,
  Cod,
  Descricao,
  Descricao_produto
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/get-produto-nfe?Cnpj=${Cnpj}`;
    if (NCM) {
      url += `&NCM=${NCM}`;
    }
    if (Cod) {
      url += `&Cod=${Cod}`;
    }
    if (Descricao) {
      url += `&Descricao=${Descricao}`;
    }
    if (Descricao_produto) {
      url += `&Descricao_produto=${Descricao_produto}`;
    }
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoProdutoNfse = async ({
  Cnpj,
  Descricao,
  Cod
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/get-produto-nfse?Cnpj=${Cnpj}`;
    if (Descricao) {
      url += `&Descricao=${Descricao}`;
    }
    if (Cod) {
      url += `&Cod=${Cod}`;
    }
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostLevdataPrecificacaoCombinarProduto = async ({
  Cnpj,
  CodProEmpresa,
  CodProFornPairs,
  id_dados_itens_v,
  id_dados_itens_c
}) => {
  // O backend pareia CodProForn com id_dados_itens_c por posição (zip), então a
  // ordem das chaves precisa ser preservada. Um objeto JS comum reordena chaves
  // numéricas (ex: códigos de barras) na serialização, então montamos o JSON
  // do dicionário manualmente a partir do array ordenado de pares.
  const codProFornJson = `{${CodProFornPairs.map(
    ([codigo, qtd]) =>
      `${JSON.stringify(String(codigo))}:${JSON.stringify(Number(qtd))}`
  ).join(',')}}`;

  const body = `{"Cnpj":${JSON.stringify(
    Cnpj
  )},"CodProEmpresa":${JSON.stringify(
    CodProEmpresa
  )},"CodProForn":${codProFornJson},"id_dados_itens_v":${JSON.stringify(
    id_dados_itens_v
  )},"id_dados_itens_c":${JSON.stringify(id_dados_itens_c)}}`;

  try {
    let user = await Auth.currentSession();
    const api = await axios.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/combinar-produto`,
      body,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostLevdataPrecificacaoCombinarServico = async ({
  Cnpj,
  CodServEmpresa,
  CodServFornPairs,
  id_nota_servico_v,
  id_nota_servico_c
}) => {
  // Mesmo cuidado do combinar-produto: o backend pareia CodServForn com
  // id_nota_servico_c por posição (zip), então a ordem das chaves precisa ser
  // preservada, o que um objeto JS comum não garante para códigos numéricos.
  const codServFornJson = `{${CodServFornPairs.map(
    ([codigo, qtd]) =>
      `${JSON.stringify(String(codigo))}:${JSON.stringify(Number(qtd))}`
  ).join(',')}}`;

  const body = `{"Cnpj":${JSON.stringify(
    Cnpj
  )},"CodServEmpresa":${JSON.stringify(
    CodServEmpresa
  )},"CodServForn":${codServFornJson},"id_nota_servico_v":${JSON.stringify(
    id_nota_servico_v
  )},"id_nota_servico_c":${JSON.stringify(id_nota_servico_c)}}`;

  try {
    let user = await Auth.currentSession();
    const api = await axios.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/combinar-servico`,
      body,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoFavoritos = async ({ Cnpj, Tipo }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/favoritos?Cnpj=${Cnpj}&Tipo=${Tipo}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiPostLevdataPrecificacaoToggleFavorito = async ({
  Cnpj,
  Tipo,
  Direcao,
  Codigo
}) => {
  try {
    let user = await Auth.currentSession();
    const api = await axios.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/favoritos/toggle`,
      { Cnpj, Tipo, Direcao, Codigo },
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoSimulacaoProduto = async ({ Cnpj }) => {
  try {
    let user = await Auth.currentSession();
    const api = await http.get(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/simulacao-produto?Cnpj=${Cnpj}`,
      user.getIdToken().getJwtToken()
    );
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoCalculoCenario = async ({
  Tipo,
  CostoBruto,
  CustoAdicional,
  Tributo,
  Margem,
  Cnpj,
  CodigoProduto,
  NomeProduto,
  CostoBrutoOriginal,
  CustoAdicionalOriginal,
  TributoOriginal,
  MargemOriginal
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/calcular-cenario?Tipo=${Tipo}&CostoBruto=${CostoBruto}&CustoAdicional=${CustoAdicional}&Tributo=${Tributo}&Margem=${Margem}&Cnpj=${Cnpj}`;
    if (CodigoProduto)
      url += `&CodigoProduto=${encodeURIComponent(CodigoProduto)}`;
    if (NomeProduto) url += `&NomeProduto=${encodeURIComponent(NomeProduto)}`;
    if (CostoBrutoOriginal !== undefined && CostoBrutoOriginal !== null)
      url += `&CostoBrutoOriginal=${CostoBrutoOriginal}`;
    if (CustoAdicionalOriginal !== undefined && CustoAdicionalOriginal !== null)
      url += `&CustoAdicionalOriginal=${CustoAdicionalOriginal}`;
    if (TributoOriginal !== undefined && TributoOriginal !== null)
      url += `&TributoOriginal=${TributoOriginal}`;
    if (MargemOriginal !== undefined && MargemOriginal !== null)
      url += `&MargemOriginal=${MargemOriginal}`;
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoCalculoTributario = async ({
  Tipo,
  CostoBruto,
  CustoAdicional,
  Tributo,
  Margem,
  Cnpj,
  credito,
  CodigoProduto,
  NomeProduto,
  CostoBrutoOriginal,
  CustoAdicionalOriginal,
  TributoOriginal,
  creditoOriginal,
  MargemOriginal
}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/calcular-tributario?Tipo=${Tipo}&CostoBruto=${CostoBruto}&CustoAdicional=${CustoAdicional}&Tributo=${Tributo}&Margem=${Margem}&Cnpj=${Cnpj}&credito=${credito}`;
    if (CodigoProduto)
      url += `&CodigoProduto=${encodeURIComponent(CodigoProduto)}`;
    if (NomeProduto) url += `&NomeProduto=${encodeURIComponent(NomeProduto)}`;
    if (CostoBrutoOriginal !== undefined && CostoBrutoOriginal !== null)
      url += `&CostoBrutoOriginal=${CostoBrutoOriginal}`;
    if (CustoAdicionalOriginal !== undefined && CustoAdicionalOriginal !== null)
      url += `&CustoAdicionalOriginal=${CustoAdicionalOriginal}`;
    if (TributoOriginal !== undefined && TributoOriginal !== null)
      url += `&TributoOriginal=${TributoOriginal}`;
    if (creditoOriginal !== undefined && creditoOriginal !== null)
      url += `&creditoOriginal=${creditoOriginal}`;
    if (MargemOriginal !== undefined && MargemOriginal !== null)
      url += `&MargemOriginal=${MargemOriginal}`;
    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetLevdataPrecificacaoHistorico = async ({
  Cnpj,
  Tipo,
  Page,
  PerPage,
  DataCriacao,
  DataInicio,
  DataFim,
  IdUsuario,
  CodigoProduto,
  NomeProduto,
  Silent
}) => {
  let user = await Auth.currentSession();
  let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/precificacao/get-historico?Cnpj=${Cnpj}&Tipo=${Tipo}`;
  if (Page) url += `&Page=${Page}`;
  if (PerPage) url += `&PerPage=${PerPage}`;
  if (DataCriacao) url += `&DataCriacao=${DataCriacao}`;
  if (DataInicio) url += `&DataInicio=${DataInicio}`;
  if (DataFim) url += `&DataFim=${DataFim}`;
  if (IdUsuario) url += `&IdUsuario=${IdUsuario}`;
  if (CodigoProduto)
    url += `&CodigoProduto=${encodeURIComponent(CodigoProduto)}`;
  if (NomeProduto) url += `&NomeProduto=${encodeURIComponent(NomeProduto)}`;
  const api = Silent
    ? await http.getSilent(url, user.getIdToken().getJwtToken())
    : await http.get(url, user.getIdToken().getJwtToken());
  return api.data;
};

export const ApiGetTabelaBc = async ({ page, per_page } = {}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/tabela-bc`;
    const params = [];
    if (page) params.push(`page=${page}`);
    if (per_page) params.push(`per_page=${per_page}`);
    if (params.length) url += `?${params.join('&')}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiGetListaCnae = async ({ page, per_page, codigo } = {}) => {
  try {
    let user = await Auth.currentSession();
    let url = `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/lista-cnae`;
    const params = [];
    if (page) params.push(`page=${page}`);
    if (per_page) params.push(`per_page=${per_page}`);
    if (codigo) params.push(`codigo=${codigo}`);
    if (params.length) url += `?${params.join('&')}`;

    const api = await http.get(url, user.getIdToken().getJwtToken());
    return api.data;
  } catch (error) {
    handleErrors(error);
  }
};

export const ApiUpdateCnaeIdBc = async ({ Id, IdBc }) => {
  try {
    let data = { Id, IdBc };
    let user = await Auth.currentSession();
    const api = await axios.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/lista-cnae/idbc`,
      data,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiCreateTabelaBc = async ({
  Atividade,
  Simples,
  AnexoSimples,
  BC
}) => {
  try {
    let data = { Atividade, Simples, AnexoSimples, BC };
    let user = await Auth.currentSession();
    const api = await axios.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/create-bc`,
      data,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiUpdateTabelaBc = async ({
  Id,
  Atividade,
  Simples,
  AnexoSimples,
  BC
}) => {
  try {
    let data = { Id, Atividade, Simples, AnexoSimples, BC };
    let user = await Auth.currentSession();
    const api = await axios.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-bc`,
      data,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiDeleteTabelaBc = async (Id) => {
  try {
    let user = await Auth.currentSession();
    const api = await axios.delete(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update-bc`,
      {
        data: { Id },
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiUpdateCnae = async ({
  Id,
  Descricao,
  AnexoPadrao,
  FatorR,
  AnexoComFatorR
}) => {
  try {
    let data = { Id, Descricao, AnexoPadrao, FatorR, AnexoComFatorR };
    let user = await Auth.currentSession();
    const api = await axios.put(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/update/cnae`,
      data,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiDeleteCnae = async ({ Id, DesLink = false }) => {
  try {
    let user = await Auth.currentSession();
    const api = await axios.delete(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/delete/cnae`,
      {
        data: { Id, DesLink },
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};

export const ApiCreateCnae = async ({
  Codigo,
  AnexoPadrao,
  Descricao,
  FatorR,
  AnexoComFatorR,
  IdBc
}) => {
  try {
    let data = { Codigo, AnexoPadrao, Descricao, FatorR, AnexoComFatorR, IdBc };
    let user = await Auth.currentSession();
    const api = await axios.post(
      `${ELEMENTAR_ANALYSIS_BASE_URL}/financeiro/lista-cnae`,
      data,
      {
        headers: {
          Authorization: `Bearer ${user.getIdToken().getJwtToken()}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return { status: api.status, data: api.data };
  } catch (error) {
    console.error('error:', error);
    return {
      status: error?.response?.status || 0,
      data: error?.response?.data || null
    };
  }
};
